module.exports = __webpack_public_path__ + "static/media/edit-icon.6e9962e5.svg";